export const ok = 0
export const syntaxError = 1
export const invalidSession = 2
export const unknownRequest = 3
export const alreadyLoggedIn = 4
export const notLoggedIn = 5
export const authError = 6
export const permissionDenied = 7
export const unknownUser = 8
export const noContractWithSelf = 9
export const errorMailUrl = 10
export const alreadyExistEmailUser = 11
export const alreadyExistLoginUser = 12
export const wrongUserStatus = 13
export const userAlreadyActif = 14
export const wrongContractActivationCode = 15
export const sendMailOK = 16
export const missingField = 17
export const notContractFound = 18
export const wrongUserParty = 19
export const errorDatabase = 20
export const projectActive = 21
export const existContractActive = 22
export const errorNotAllUserJoined = 23
export const errorWrongContractStatus = 24
export const needToChangePassword = 25
export const sendBLCcreateAccount = 26
export const sendBLCdeployContract = 27
export const errorBLCcreateAccount = 28
export const errorBLCdeployContract = 29
export const missingUserPassphrase = 30
export const permissionError = 31
export const invalidKeys = 32
export const keyNotFound = 33
export const verifyKeyError = 34
export const keyIdNotMatch = 35
export const keyAlreadyExists = 36
